import React from "react";
import "./Vehicles.css";

// const vehicles = [
//   {
//     id: 1,
//     name: "Swift Dzire",
//     type: "Sedan",
//     price: "Book Now",
//     image: "/images/Fleet/Swift-Dzire.jpg",
//     seats: "4+1 Seats",
//     bags: "2 Bags",
//     ac: "Air Conditioned",
//     transmission: "Manual / Auto",
//   },
//   {
//     id: 2,
//     name: "Maruti Ertiga",
//     type: "Family MPV",
//     price: "Book Now",
//     image: "/images/Fleet/Maruti-Ertiga.jpg",
//     seats: "6+1 Seats",
//     bags: "3 Bags",
//     ac: "Air Conditioned",
//     transmission: "Manual",
//   },
//   {
//     id: 3,
//     name: "Toyota Rumion",
//     type: "Premium MPV",
//     price: "Book Now",
//     image: "/images/Fleet/Toyota-Rumion.jpg",
//     seats: "6+1 Seats",
//     bags: "3 Bags",
//     ac: "Air Conditioned",
//     transmission: "Manual",
//   },
//   {
//     id: 4,
//     name: "Kia Carens",
//     type: "Luxury MPV",
//     price: "Book Now",
//     image: "/images/Fleet/Kia-Carens.jpg",
//     seats: "6+1 Seats",
//     bags: "4 Bags",
//     ac: "Dual AC",
//     transmission: "Manual",
//   },
//   {
//     id: 6,
//     name: "Innova Crysta",
//     type: "Premium SUV",
//     price: "Book Now",
//     image: "/images/Fleet/Innova-Crysta.jpg",
//     seats: "7 Seats",
//     bags: "5 Bags",
//     ac: "Climate AC",
//     transmission: "Manual",
//   },
//   {
//     id: 7,
//     name: "Tempo Traveller",
//     type: "Traveller",
//     price: "Book Now",
//     image: "/images/Fleet/Tempo-Traveller.jpg",
//     seats: "12-17 Seats",
//     bags: "10 Bags",
//     ac: "Air Conditioned",
//     transmission: "Manual",
//   },
// ];


const vehicles = [
  {
    id: 1,
    name: "Swift Dzire",
    type: "Sedan",
    price: "Book Now",
    image: "/images/Fleet/dzire.jpg",
    seats: "4+1 Seats",
    bags: "2 Bags",
    ac: "Air Conditioned",
    transmission: "Manual / Auto",
  },
  {
    id: 2,
    name: "Maruti Ertiga",
    type: "Family MPV",
    price: "Book Now",
    image: "/images/Fleet/ertiga.jpg",
    seats: "6+1 Seats",
    bags: "3 Bags",
    ac: "Air Conditioned",
    transmission: "Manual",
  },
  // {
  //   id: 3,
  //   name: "Toyota Rumion",
  //   type: "Premium MPV",
  //   price: "Book Now",
  //   image: "/images/Fleet/rumion.jpg",
  //   seats: "6+1 Seats",
  //   bags: "3 Bags",
  //   ac: "Air Conditioned",
  //   transmission: "Manual",
  // },
  {
    id: 4,
    name: "Kia Carens",
    type: "Luxury MPV",
    price: "Book Now",
    image: "/images/Fleet/kia.jpg",
    seats: "6+1 Seats",
    bags: "4 Bags",
    ac: "Dual AC",
    transmission: "Manual",
  },
  {
    id: 5,
    name: " Innova Crysta",
    type: "Premium SUV",
    price: "Book Now",
    image: "/images/Fleet/Innova-Crysta.jpg",
    seats: "7 Seats",
    bags: "5 Bags",
    ac: "Climate AC",
    transmission: "Manual",
  },
  // {
  //   id: 6,
  //   name: " Innova Hycross",
  //   type: "Premium Hybrid SUV",
  //   price: "Book Now",
  //   image: "/images/Fleet/Innova-hycross.jpg",
  //   seats: "7 Seats",
  //   bags: "5 Bags",
  //   ac: "Climate AC",
  //   transmission: "Automatic",
  // },
  {
    id: 7,
    name: "Tempo Traveller",
    type: "Traveller",
    price: "Book Now",
    image: "/images/Fleet/trmpo-traveller.jpg",
    seats: "12-17 Seats",
    bags: "10 Bags",
    ac: "Air Conditioned",
    transmission: "Manual",
  },
  {
    id: 8,
    name: "Force Urbania",
    type: "Luxury Van",
    price: "Book Now",
    image: "/images/Fleet/Urbania-Bus.jpg",
    seats: "13-17 Seats",
    bags: "12 Bags",
    ac: "Air Conditioned",
    transmission: "Manual",
  },
  // {
  //   id: 9,
  //   name: "Mini Bus",
  //   type: "Mini Bus",
  //   price: "Book Now",
  //   image: "/images/Fleet/mini-bus.jpg",
  //   seats: "20-25 Seats",
  //   bags: "20 Bags",
  //   ac: "Air Conditioned",
  //   transmission: "Manual",
  // },
];

const Vehicles = () => {
  return (
    <section className="vehicles-section p-0">

      <div className="vehicles-container">

        {/* Heading */}
        <div className="vehicles-heading">

          <div className="heading-title">

            <div className="heading-line left">
              <span></span>
              <span></span>
              <span></span>
            </div>

            <h2>Our Premium Fleet</h2>

            <div className="heading-line right">
              <span></span>
              <span></span>
              <span></span>
            </div>

          </div>

          <p>
            Sai Shirdi Cab offers a reliable range of clean, comfortable and
            well-maintained vehicles for Shirdi Sai Baba Darshan, Mumbai to
            Shirdi Cab, Pune to Shirdi Taxi, Nashik to Shirdi Cab, Airport
            Transfers, Local Sightseeing and Outstation Taxi Services.
            Choose the right vehicle for your family, group or pilgrimage
            journey and travel to Shirdi with comfort and peace of mind.
          </p>

        </div>

        {/* Fleet Cards */}
        <div className="vehicle-grid">

          {vehicles.map((car) => (

            <div
              className="vehicle-card"
              key={car.id}
            >

              <a
                href="/booking"
                className="vehicle-image"
              >

                <img
                  src={car.image}
                  alt={`${car.name} Cab for Shirdi`}
                />

              </a>

              <div className="vehicle-content">

                <div className="vehicle-top">

                  <div>

                    <h3 className="textg">
                      {car.name}
                    </h3>

                    <span>{car.type}</span>

                  </div>

                  <div className="price">

                    <strong>{car.price}</strong>

                    <span>24×7 Cab Service</span>

                  </div>

                </div>

                <div className="vehicle-info text-center">

                  <div>
                    <i className="fa-solid fa-users"></i>
                    <span>{car.seats}</span>
                  </div>

                  <div>
                    <i className="fa-solid fa-suitcase"></i>
                    <span>{car.bags}</span>
                  </div>

                  <div>
                    <i className="fa-solid fa-snowflake text-center"></i>
                    <span>{car.ac}</span>
                  </div>

                </div>

                <div className="vehicle-buttons">

                  {/* Book Now button can be added here */}

                </div>

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
};

export default Vehicles;
